/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { Component } from 'react';

import redirect from 'js/lib/coursera.redirect';

import Alert from 'bundles/authentication/shared/Alert';
import type { MODES } from 'bundles/authentication/shared/components/authentication-modal/AuthenticationContent';
import API from 'bundles/phoenix/lib/apiWrapper';

import _t from 'i18n!nls/authentication';

type Props = {
  id: string;
  navigate: (path: MODES, options?: $TSFixMe) => void;
};

type State = {
  error?: string;
};

const styles = {
  container: css`
    display: grid;
    grid-gap: var(--cds-spacing-400);
    grid-template-columns: 1fr;
    margin: 0 auto;
    padding: var(--cds-spacing-400) var(--cds-spacing-200);
    max-width: 396px;
  `,
};

class Redirection extends Component<Props, State> {
  state: State = {};

  async componentDidMount() {
    const { id } = this.props;

    const searchParams = new URLSearchParams();
    searchParams.append('action', 'initiateLoginFlow');
    searchParams.append('id', id);
    searchParams.append('returnTo', redirect.getPathname() + redirect.getQueryParams());

    // Redirect to the SSO login
    try {
      window.location = await API('/api/thirdPartyOrganizations.v1').post(`?${searchParams.toString()}`);
    } catch (error) {
      this.setState({ error });
    }
  }

  render() {
    const { error } = this.state;

    return (
      <section css={styles.container}>
        <header>
          <h1>{_t('Redirecting')}</h1>
        </header>
        {error && <Alert>{error}</Alert>}
      </section>
    );
  }
}

export default Redirection;
